export enum StatusCode {
  UnknownError = 460,
  NetworkError = 461,
  Timout = 408,
  SchemaParseError = 520,
}
